export const getDocumentCharset = () => {
  return `${document.characterSet || document.charset || ""}`.toLowerCase();
};

export const getRootElement = () => {
  const a = document.documentElement;
  return "CSS1Compat" === document.compatMode ? a : document.body || a;
};

export const getViewportSize = () => {
  const a = getRootElement();

  return [
    a.clientWidth || window.innerWidth,
    a.clientHeight || window.innerHeight,
  ];
};

export const getDocumentTitle = () => {
  let a = document.title;
  "string" !== typeof a &&
    (a =
      (a = document.getElementsByTagName("title")) && a.length
        ? a[0].innerHTML
        : "");
  return a;
};

export const getUtmParameters = () => {
  const utmParameters = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term",
  ];

  const queryParams = window.location.search.replace("?", "").split("&");
  const utmValues = {};

  utmParameters.forEach((param) => {
    utmValues[param] = null;
  });

  queryParams.forEach((item) => {
    let [key, value] = item.split("=");
    key = key.toLowerCase();
    if (utmParameters.includes(key)) {
      utmValues[key] = value;
    }
  });

  return utmValues;
};

export const isFromAd = () => {
  if (!document.referrer) {
    return false;
  }

  const adSystemSources = [
    "adfox",
    "admitad",
    "adnews",
    "adnous",
    "adriver",
    "advmaker",
    "aport",
    "aport.ru",
    "AvitoPromo",
    "AvitoContext",
    "begun",
    "bing",
    "B2BContext",
    "criteo",
    "directadvert",
    "directadvert.ru",
    "drivenetwork",
    "facebook",
    "fb",
    "facebook.com",
    "fb.com",
    "giraffio",
    "google",
    "adwords",
    "adsense",
    "instagram",
    "kavanga",
    "ladycenter",
    "link",
    "magna",
    "marketgid",
    "medialand",
    "merchant",
    "moimir",
    "nnn",
    "nnn.ru",
    "odnoklassniki",
    "price",
    "price.ru",
    "prre",
    "mytarget",
    "targetmailru",
    "taboola",
    "torg.mail.ru",
    "trorer",
    "rorer",
    "Ttarget",
    "ubn.ua",
    "banner.ua",
    "videonow",
    "vkontakte",
    "vk",
    "vk.com",
    "whisla",
    "youtube",
  ];
  const adSystemMediums = [
    "cpc",
    "ppc",
    "paidsearch",
    "cpv",
    "cpa",
    "cpp",
    "display",
    "cpm",
    "banner",
  ];

  const queryParams = window.location.search.replace("?", "").split("&");
  const hashParams = window.location.hash.replace("#", "").split("&");
  const params = hashParams.concat(queryParams);

  let isAd = false;
  params.forEach((item) => {
    let p = item.split("=");
    if (p[0] === "utm_source" && p[1] && adSystemSources.indexOf(p[1])) {
      return (isAd = true);
    }
    if (p[0] === "utm_medium" && p[1] && adSystemMediums.indexOf(p[1])) {
      return (isAd = true);
    }
  });

  return isAd;
};

export const extractHostname = (url) => {
  if (url === undefined || url === "") {
    return "";
  }
  let hostname;

  //find & remove protocol (http, ftp, etc.) and get hostname
  if (url.includes("://")) {
    hostname = url.split("/")[2];
  } else {
    hostname = url.split("/")[0];
  }

  //find & remove port number
  hostname = hostname.split(":")[0];
  //find & remove "?"
  hostname = hostname.split("?")[0];
  hostname = hostname.replace(/^www\./, "");
  hostname = hostname.replace("#", "");

  return hostname;
};

export const isExternal = (siteDomains, linkUrl) => {
  const hostname = extractHostname(linkUrl);

  if (Array.isArray(siteDomains)) {
    if (hostname === "" || siteDomains.includes(hostname)) {
      return false;
    }
  } else {
    return !(
      extractHostname(window.location.hostname) === hostname || hostname === ""
    );
  }

  return true;
};

export const isInternal = (siteDomains, linkUrl) => {
  const hostname = extractHostname(linkUrl);
  const currHostname = window.location.hostname;

  if (currHostname === hostname) {
    return false;
  }

  if (Array.isArray(siteDomains)) {
    if (hostname === "" || siteDomains.includes(hostname)) {
      return true;
    }
  } else {
    return true;
  }
  return false;
};
